import LogoWhite from "../../static/images/logo-white.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt, faClock } from "@fortawesome/free-solid-svg-icons";

// Updated QUOTE links — matches the homepage "Insurance Solutions" section and
// the Compare Rates nav dropdown (the new product lineup).
const QUOTE_LINKS = [
    { label: "Auto Insurance", to: "/auto-insurance-quote" },
    { label: "Homeowners Insurance", to: "/home-owner-insurance" },
    { label: "Commercial Auto Insurance", to: "/commercial-auto-insurance" },
    { label: "Trucking Insurance", to: "/trucking-insurance" },
    { label: "Business Insurance", to: "/business-insurance" },
    { label: "Workers Compensation", to: "/workers-compensation-insurance" },
    { label: "Earthquake Insurance", to: "/earthquake-insurance" },
];

const CONTACT_TEXT = { color: "#cdd7e6", fontSize: "0.85rem", lineHeight: "2" };
const CONTACT_LINK = { color: "#cdd7e6", textDecoration: "none" };
const CONTACT_ICON = { color: "#90CF36", marginRight: "8px", width: "16px" };

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <>
            <div className="footer">
                <div id="one" className="column">
                    <Link to="/">
                        <img id="logo-footer" src={LogoWhite} alt="GM Insurance Services" width="466" height="104" />
                    </Link>
                    <p style={{ ...CONTACT_TEXT, marginTop: "1.2em", maxWidth: "270px" }}>
                        California's trusted independent insurance broker since 2007, helping individuals
                        and businesses compare coverage and find the right protection.
                    </p>
                    <div style={{ ...CONTACT_TEXT, marginTop: "1em" }}>
                        <div>
                            <FontAwesomeIcon icon={faPhoneAlt} style={CONTACT_ICON} />
                            <a href="tel:8773338303" style={CONTACT_LINK}>877.333.8303</a>
                        </div>
                        <div>
                            <FontAwesomeIcon icon={faClock} style={CONTACT_ICON} />
                            Mon–Fri, 9:00 AM – 6:00 PM
                        </div>
                    </div>
                </div>

                <div id="two" className="column">
                    <strong className="strong footer-links-headin">QUOTE</strong>
                    <ul id="links-footer">
                        {QUOTE_LINKS.map((l) => (
                            <Link to={l.to} key={l.to}><li>{l.label}</li></Link>
                        ))}
                    </ul>
                </div>

                <div id="three" className="column">
                    <strong className="strong footer-links-headin">CLIENT SERVICES</strong>
                    <ul id="links-footer">
                        <Link to="/make-payment-online"><li>Make a Payment</li></Link>
                        <Link to="/roadside-assistance"><li>Roadside Assistance</li></Link>
                        <Link to="/request-change"><li>Request a Change</li></Link>
                    </ul>
                </div>

                <div id="four" className="column">
                    <strong className="strong footer-links-headin">About Us</strong>
                    <ul id="links-footer">
                        <Link to="/about-us"><li>About Us</li></Link>
                        <Link to="/career"><li>Careers</li></Link>
                        <Link to="/contact-us"><li>Contact Us</li></Link>
                        <Link to="/privacy-policy"><li>Privacy Policy</li></Link>
                        <Link to="/customer-reviews"><li>Customer Reviews</li></Link>
                        <Link to="/website-accessibility"><li>Website Accessibility</li></Link>
                    </ul>
                </div>
            </div>

            <div className="copyright">
                <p>Copyright © 2007 - {year} GM Insurance Services. All Rights Reserved. License No 0H00443</p>
            </div>
        </>
    );
}
